import Prismic from 'prismic-javascript';

const apiEndpoint = 'https://foul-studios.cdn.prismic.io/api/v2'

const apiToken = 'MC5XNmZsdnljQUFDVUE0NHJv.77-977-977-9He-_vUdVfBnvv73vv70BD--_vRN8b--_vTbvv73vv70RMO-_ve-_ve-_vStZ77-977-9OGM';

var prismic =  Prismic.getApi(apiEndpoint, {accessToken: apiToken});

export default prismic;
